<template>
	<div>
		<template>  <!-- v-if="!isLoading -->
			<v-container class="grey lighten-5">
			<v-row no-gutters>
				<v-col cols="12" sm="6" md="4">
				<v-card class="pa-2" outlined tile>
					<!-- {{ $t('personalDetails') }} -->
					<br>
					<h4 class="card-title card-name">{{ cleaner.cleaner.firstName }} {{ cleaner.cleaner.lastName }}</h4>
					<p class="card-text">{{ $t('contactNo') }}: {{ cleaner.cleaner.contact_no }}</p>
					<br>
					<!--MODAL--->
					<div>
					<button class="add-btn" @click="$bvModal.show('contactNo-modal')"
						> {{ $t('changeContactNo') }}</button
					>
					<!--LINK TO MODAL - CREATE UNIT PRODUCT - URL: units/unitId/productId-->
					<b-modal id="contactNo-modal" hide-footer>
						<template v-slot:modal-title>
						{{ $t('addContactNo') }}
						</template>
						<CleanerDetailsModal :contact="cleaner.cleaner.contact_no" @update-success="updateSuccess"/>
					</b-modal>
					</div>
					<!--END OF MODAL-->
				</v-card>
				</v-col>
				<v-col cols="6" md="4">
				<!-- <v-card class="pa-2" outlined tile>
					<div class="prodInfo">
					<h1>Products on sale</h1>
					<section v-if="errored">
						<p>
						We are sorry, we are not able to retrieve this information
						at the moment. Please try back later.
						</p>
					</section>
					<section v-else>
						<div v-if="loading">Loading...</div>
						<div v-else>
						<table>
							<thead>
							<tr>
								<th>Product Name</th>
								<th>Price</th>
							</tr>
							</thead>
							<tbody>
							<tr
								v-for="prodInfo in prodInfo"
								class="info"
								v-bind:key="prodInfo"
							>
								<td>
								{{ prodInfo.name }}
								</td>
								<td>
								{{ prodInfo.price }}
								</td>
							</tr>
							</tbody>
						</table>
						</div>
					</section>
					</div>
				</v-card> -->
				</v-col>
			</v-row>
			</v-container>
		</template>
		<!-- <p v-else>
		Loading products
		</p> -->
	</div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'
import CleanerDetailsModal from '@/components/ui/SupportDetailsModal.vue'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

import { mapState } from 'vuex'

export default {
	metaInfo() {
    return {
      title: this.$i18n.t('profile'),
    }
  },
	components: {
		CleanerDetailsModal
	},
	data() {
		return {
		isLoading: true,
		products: [],
		prodInfo: null,
		loading: true,
		errored: false
		}
	},

	created() {
		axios
		.get(`${process.env.VUE_APP_API_URL}/dashboard`)
		.then(response => {
			// handle success
			this.products = response.data.products.products
			this.isLoading = false
		})
		.catch(error => {
			// handle error
			console.log(error)
		})
	},
	mounted() {
		axios
		.get(`${process.env.VUE_APP_API_URL}/products`)
		.then(response => {
			this.prodInfo = response.data
		})
		.catch(error => {
			console.log(error)
			this.errored = true
		})
		.finally(() => (this.loading = false))
	},
	methods: {
		updateSuccess() {
		this.$bvModal.hide('contactNo-modal')
		}
	},
	computed: mapState(['cleaner']),
	}
	</script>

	<style lang="css" scoped>
	.add-btn {
	background: var(--primaryDark) !important;
	color: var(--bright);
	padding: 1em;
	letter-spacing: 3px;
	border-radius: 5px;
	width: 60%;
	}

	@media screen and (max-width: 780px){
	.add-btn {
	width: 80%;
	}
}

</style>
